/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
/** @jsx jsx */
import React, { forwardRef } from 'react';
import { css, jsx } from '@emotion/react';
import { UNSAFE_Box as Box, UNSAFE_Text as Text } from '@atlaskit/ds-explorations';
import Inline from '@atlaskit/primitives/inline';
import { N0, N500, N700, R400, Y300 } from '@atlaskit/theme/colors';
// Applies styles to nested links within banner messages.
var nestedLinkStyles = css({
  // eslint-disable-next-line @repo/internal/styles/no-nested-styles
  'a, a:visited, a:hover, a:focus, a:active': {
    color: 'currentColor',
    textDecoration: 'underline'
  }
});
var backgroundColors = {
  warning: 'warning.bold',
  error: 'danger.bold',
  announcement: 'neutral.bold'
};
var tokenBackgroundColors = {
  warning: "var(--ds-background-warning-bold, ".concat(Y300, ")"),
  error: "var(--ds-background-danger-bold, ".concat(R400, ")"),
  announcement: "var(--ds-background-neutral-bold, ".concat(N500, ")")
};
var textColors = {
  warning: 'warning.inverse',
  error: 'inverse',
  announcement: 'inverse'
};
var tokenTextColors = {
  warning: "var(--ds-text-warning-inverse, ".concat(N700, ")"),
  error: "var(--ds-text-inverse, ".concat(N0, ")"),
  announcement: "var(--ds-text-inverse, ".concat(N0, ")")
};
/**
 * __Banner__
 *
 * A banner displays a prominent message at the top of the screen.
 *
 * - [Examples](https://atlassian.design/components/banner/examples)
 * - [Code](https://atlassian.design/components/banner/code)
 * - [Usage](https://atlassian.design/components/banner/usage)
 */
var Banner = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'warning' : _ref$appearance,
    children = _ref.children,
    icon = _ref.icon,
    testId = _ref.testId;
  var appearanceType = appearance in backgroundColors ? appearance : 'warning';
  return jsx(Box, {
    display: "block",
    backgroundColor: backgroundColors[appearanceType],
    overflow: "hidden",
    padding: "space.150",
    testId: testId,
    ref: ref,
    role: "alert",
    UNSAFE_style: {
      maxHeight: '48px'
    },
    css: nestedLinkStyles
  }, jsx(Inline, {
    space: "space.050",
    alignBlock: "center",
    alignInline: "start"
  }, icon ? jsx(Box, {
    as: "span",
    display: "inline",
    width: "size.200",
    height: "size.200" // This matches Icon's "medium" size, without this the (line-)height is greater than that of the Icon
    ,
    UNSAFE_style: {
      fill: tokenBackgroundColors[appearanceType],
      color: tokenTextColors[appearanceType],
      flexShrink: 0
    }
  }, icon) : null, jsx(Text, {
    fontWeight: "medium",
    lineHeight: "lineHeight.300",
    color: textColors[appearanceType],
    shouldTruncate: true
  }, children)));
});
export default Banner;